import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { dropdownAPIs, userAPIs } from '@/services/authConstantsV1'
import { Select } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Select)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-select 
        show-search 
        size="small" 
        placeholder="Select Role" 
        v-model="roleName" 
        style="width: 100%;" 
        @change="handleChange"
        :dropdownStyle="{
          minWidth: 'auto !important',
          overflow: 'auto !important'
        }"
      >
        <a-select-option v-for="role in roles" :value="role.option" :key="role.id">
          {{ role.option }}
        </a-select-option>
      </a-select>
    </div>
    `,

  data() {
    return {
      roles: [],
      roleName: null,
    }
  },
  beforeMount() {
    this.params.roles.then(roles => { this.roles = roles })
  },
  created() {
    this.roleName = this.params.value
  },
  methods: {
    getUserRoles() {
      instance
        .post(dropdownAPIs.dropdown, { role: 0 })
        .then(response => {
          this.roles = _.get(response.data, 'result.role', [])
        })
        .catch(error => {
          errorService(error)
        })
    },

    handleChange(value) {
      const roles = this.roles.find(i => i.option === value)
      this.updateUserRole(roles)
    },

    getValue() {
      return this.roleName
    },

    // Update User Role
    updateUserRole(roles) {
      instance.patch(userAPIs.role(this.params.data.id, roles.id))
        .then(response => {
          this.$notification.open({
            message: 'Update User',
            description: response.data.message,
            icon: <a-icon type="check-circle" style="color: #46be8a" />,
          })
          this.roleName = roles.option
          this.params.value = this.roleName
        }).catch(error => {
          errorService(error)
        })
    },
  },
})
